const type = 'SHOW_BLOCKED_MODAL';

const showBlockedModal = (data) => ({
  data,
  type,
});

export { type };
export default showBlockedModal;
